import { useContext } from 'react';

import { alpha, styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Link } from '@mui/material';
import HideOnScroll from '../../components/HideOnScroll';

import LoginButtons from './LoginButtons';
import Logo from '../../components/Logo';
import { Link as RouterLink } from 'react-router-dom';
import { Web3AuthContext } from '../../contexts/Web3Auth';

import HeaderUserbox from '../SidebarLayout/Header/Userbox';
const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  padding: 20
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5)
  }
}));

export default function HeaderOnlyNavbar() {
  const { user } = useContext(Web3AuthContext);
  return (
    <HideOnScroll threshold={20}>
      <RootStyle>
        <ToolbarStyle>
          <Link
            underline="none"
            component={RouterLink}
            to={{
              pathname: `/`
            }}
          >
            <Logo logoTextColor={'primary.main'} />
          </Link>

          <Box sx={{ flexGrow: 1 }} />

          <Stack
            direction="row"
            alignItems="center"
            spacing={{ xs: 0.5, sm: 1.5 }}
          >
            {user ? <HeaderUserbox /> : <LoginButtons />}
          </Stack>
        </ToolbarStyle>
      </RootStyle>
    </HideOnScroll>
  );
}
